<template>
  <div class="hover-dot" :style="{transform: `translate3d(${x.value}px, ${y.value}px, 0)`}" >
    <transition>
      <div class="dot" v-if="hoverTarget" key="dot" />
    </transition>
  </div>
</template>

<script>
import delay from 'lodash/delay'
import { RAF, ElasticNumber } from '@monogrid/js-utils'

export default {
  name: 'HoverDot',

  mounted () {
    this.time = new Date().getTime()
    document.addEventListener('mouseover', this.onMouseOver)
    document.addEventListener('mouseout', this.onMouseOut)
    document.addEventListener('click', this.onMouseOut)
    RAF.add(this.render)
  },

  destroyed () {
    document.removeEventListener('mouseover', this.onMouseOver)
    document.removeEventListener('mouseout', this.onMouseOut)
    document.removeEventListener('click', this.onMouseOut)
    RAF.remove(this.render)
  },

  data () {
    return {
      hoverTarget: null,
      x: new ElasticNumber(0),
      y: new ElasticNumber(0)
    }
  },

  // watch: {
  //   async $route () {
  //     clearTimeout(this.outDelay)
  //     await this.$nextTick()
  //     this.hoverTarget = null
  //   }
  // },

  methods: {
    render () {
      const now = new Date().getTime()
      const delta = (now - this.time) / 1000

      if (this.hoverTarget) {
        if (!document.body.contains(this.hoverTarget)) {
          // console.log('detached hover target, removing')
          // clearTimeout(this.outDelay)
          this.hoverTarget = null
        } else {
          const rect = this.hoverTarget.getBoundingClientRect()
          const data = JSON.parse(this.hoverTarget.dataset.hoverDotTarget)
          this.x.target = rect.x + data.x
          this.y.target = rect.y + data.y
        }
      }
      this.x.update(delta)
      this.y.update(delta)
      this.time = now
    },
    // onScroll () {
    //   this.scrollValue = document.documentElement.pageYOffset || document.documentElement.scrollTop
    // },
    searchData (domElement) {
      if (!domElement) {
        return false
      }
      if (domElement.dataset && domElement.dataset.hoverDotTarget !== null && domElement.dataset.hoverDotTarget !== undefined) {
        return domElement
      }
      if (domElement.parentNode) {
        return this.searchData(domElement.parentNode)
      }
      return false
    },
    onMouseOut (e) {
      const dataTarget = this.searchData(e.target)
      if (dataTarget) {
        // clearTimeout(this.outDelay)
        // console.log('mouse OUT target')
        this.outDelay = delay(() => {
          // console.log('delayed disappearance')
          this.hoverTarget = null
        }, 300)
      }
    },
    onMouseOver (e) {
      const dataTarget = this.searchData(e.target)
      if (dataTarget) {
        // console.log('mouse over target')
        clearTimeout(this.outDelay)
        // initial placement when dot was NOT over anything
        if (!this.hoverTarget) {
          const rect = dataTarget.getBoundingClientRect()
          const data = JSON.parse(dataTarget.dataset.hoverDotTarget)
          this.x.value = rect.x + data.x
          this.y.value = rect.y + data.y
        }
        this.hoverTarget = dataTarget
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.hover-dot {
  position: fixed;
  // content: '';
  top: 0;
  left: 0;
  // transition: transform 0.5s $ease-in-out-cubic;
  // left: -20px;
  // opacity: 0;
  // transition: opacity 0.3s;
  z-index: 999999;
  // pointer-events: none;
  // user-select: none;
}

.dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: map-get($shades, 'black');
}
</style>
